export const pathes = {
    DEFAULT: "/",
    VEHICLE_INFORMATION:"/vehicle-information",
    ADD_VEHICLE:"/add-vehicle",
    VEHICLE_SELECTION:"/vehicle-selection",
    EMPTY_VEHICLE_SELECTION:"/empty-car-selection",
    BASE_PATH:"/vehicle-profile",
}
export const flowPathes={
    AFTER_SELECT_CAR:pathes.VEHICLE_INFORMATION,
    AFTER_ADD_CAR:pathes.DEFAULT
}